 
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useDiscountPatientPayTable from "./hooks/useDiscountPatientPayTable";  
  
const DiscountPatientPayTable = () => {  
  const discountPatientPayTableData = useDiscountPatientPayTable();  
  
  return (  
    <div class="container container-fluid"> 
      {discountPatientPayTableData.leftButtons.length > 0 && <ButtonsSection
        ctaButtons={discountPatientPayTableData.leftButtons}
        align="left"
      />} 
      <div className="header-section">  
        <h1>  
          {discountPatientPayTableData.screen_title} -{" "}  
          <span className="heading-cod">{discountPatientPayTableData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={discountPatientPayTableData.formFields}  
        dropdownValues={discountPatientPayTableData.dropdownValues}  
        paramsData={discountPatientPayTableData.paramsData}  
        updataParamData={discountPatientPayTableData.updateParamData} 
        disabledDropdown={discountPatientPayTableData.disabledDropdown} 
      />  
      <ButtonsSection ctaButtons={discountPatientPayTableData.ctaButtons} />  
      <DisplayTable  
        data={discountPatientPayTableData.data}  
        parmKey={discountPatientPayTableData.parmKey}  
        menuOptions={discountPatientPayTableData.menuOptions}  
        tableHeaders={discountPatientPayTableData.columnDef}  
        setRowData={discountPatientPayTableData.setRowData}  
        selectedPriceSchedules={discountPatientPayTableData.selectedRows}  
        setSelectedPriceSchedules={discountPatientPayTableData.setSelectedRows}  
        selectMode={discountPatientPayTableData.selectMode}   
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={discountPatientPayTableData.first}  
          rows={discountPatientPayTableData.rows}  
          totalRecords={discountPatientPayTableData.totalRecords}  
          currentPage={discountPatientPayTableData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={discountPatientPayTableData.onPageChange}  
        />  
      </div>  
      {discountPatientPayTableData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={discountPatientPayTableData.isConfirmationModalOpen}  
          onRequestClose={discountPatientPayTableData.closeConfirmationModal}  
          onBack={discountPatientPayTableData.closeConfirmationModal}  
          onSave={discountPatientPayTableData.deleteDiscountPatientPayTable}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={discountPatientPayTableData.setSelectedOption}  
        />  
      )}  
      {discountPatientPayTableData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={discountPatientPayTableData.isHideConfirmationModalOpen}
          onRequestClose={discountPatientPayTableData.closeHideConfirmationModal}
          onBack={discountPatientPayTableData.closeHideConfirmationModal}
          onSave={discountPatientPayTableData.hidePatientPayTable}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={discountPatientPayTableData.setHideSelectedOption}
        />
      )}
    </div>  
  );  
};  
  
export default DiscountPatientPayTable;  